import styled, { css, device, color, themeGet } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 60px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-start: 80px;
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-start: 100px;
    padding-block-end: 90px;
  }
  ${color}
`

export const TabsWrapper = styled.div`
  margin-block-start: 25px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  button {
    height: 100%;
  }
`

export const CheckWrapper = styled.div`
  margin-top: 30px;
  padding: 20px;
  border-radius: 2px;
  border: 1px solid ${themeGet('colors.border')};
  div {
    display: flex;
  }
  input {
    margin-top: 5px;
    margin-right: 10px;
  }
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  a {
    :hover {
      text-decoration: underline !important;
    }
  }
`

export const StyledTitle = styled.p`
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  color: ${(props) => props.color};
`

export const StyledText2 = styled.div`
  margin-block-start: 15px;
  text-align: center;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: ${themeGet('colors.secondary')};
  justify-content: center;
  scroll-margin-top: 100px;
`

export const SectionBody = styled.div`
  padding-block-start: 60px;
  padding-block-end: 50px;
  scroll-margin-top: 70px;
  ${device.medium} {
    padding-block-start: 80px;
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-start: 100px;
    padding-block-end: 90px;
    scroll-margin-top: 50px;
  }
`

export const SectionBottom = styled.div`
  margin-block-start: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  ${device.small} {
    flex-direction: row;
  }
`

export const ClassificationItem = styled.div`
  border-radius: ${themeGet('radii.md')};
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  font-size: 18px;
  padding: 20px 30px 20px;
  ${device.small} {
    padding: 33px 50px 36px;
  }
  ${(props) => {
    if (!props.isEven) {
      return css`
        background: ${props.color};
      `
    }
  }}
`

export const SVGWrapper = styled.div`
  marginleft: auto;
  marginright: auto;
  display: none;
  ${device.large} {
    display: block;
  }
`

export const SummaryCircleWrapper = styled.div`
  marginleft: auto;
  marginright: auto;
  display: block;
  ${device.large} {
    display: none;
  }
`

export const CircleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`

export const Circle = styled.div`
  @keyframes left {
    from {
      opacity: 0;
      transform: translateX(-100px) rotate(-180deg);
    }
    to {
      opacity: 1;
      transform: translateX(0px) rotate(0deg);
    }
  }
  @keyframes right {
    from {
      opacity: 0;
      transform: translateX(100px) rotate(180deg);
    }
    to {
      opacity: 1;
      transform: translateX(0px) rotate(0deg);
    }
  }
  @keyframes middle {
    from {
      opacity: 0;
      transform: translateY(100px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  transition: 450ms;
  :hover {
    opacity: 0.8;
    cursor: pointer;
  }
  animation-name: ${(props) => props.animation};
  animation-duration: 2s;
  display: flex;
  margin-right: 5px;
  margin-left: 5px;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  background: ${(props) => props.background};
  border-radius: 50%;
  height: 100px;
  width: 100px;
  min-width: 100px;
  top: 50%;
  font-size: 12px;
  ${device.medium} {
    width: 120px;
    height: 120px;
    font-size: 13px;
  }
  ${device.large} {
    font-size: 15px;
    width: 150px;
    height: 150px;
  }
`
